import { combineReducers } from "redux";
import { reducer as oidcReducer } from "redux-oidc";
import worklistFilterReducer from "./worklistFilter";
import workItemsReducer from "./workItemsReducer";
import summaryReducer from "./summaryReducer";
import messageReducer from "./messageReducer";
import loaderReducer from "./soleraLoaderReducer";
import reportsReducer from "./reportsReducer";
import iframeReducer from "./iframeReducer";
import paginationReducer from "store/common/pagination/reducer";
import sortingReducer from "store/common/sorting/reducer";
import workListColumns from "./workListColumns";
import user from "./userReducer";
import featuresReducer from "./featuresReducer";
import preferencesReducer from "./preferencesReducer";
import changeRoleReducer from "./changeRoleReducer";

const rootReducer = combineReducers({
  workItems: workItemsReducer,
  worklistFilterReducer,
  summaryReducer,
  oidc: oidcReducer,
  messages: messageReducer,
  loader: loaderReducer,
  iframe: iframeReducer,
  pagination: paginationReducer,
  sorting: sortingReducer,
  workListColumns,
  user,
  features: featuresReducer,
  preferences: preferencesReducer,
  reports: reportsReducer,
  ghosting: changeRoleReducer
});

export default rootReducer;
